import React from "react";
import { Navigate } from "react-router-dom";
import { isBrokerPortalHost, BROKER_PORTAL_LANDING } from "../constants/portalHosts";

// Dashboard

//

//Pages
// import PagesStarter from "../pages/Utility/pages-starter"
import Pages404 from "../pages/Utility/pages-404";
import Pages500 from "../pages/Utility/pages-500";
import PagesMaintenance from "../pages/Utility/pages-maintenance";

// Authentication related pages
import Loginnew from "../pages/Authentication/Auth";
import ForgetPwd from "../pages/Authentication/ForgetPassword";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import LockScreen from "../pages/AuthenticationInner/auth-lock-screen";
import Login1 from "../pages/AuthenticationInner/Login";
import Recoverpw from "../pages/AuthenticationInner/Recoverpw";
import Register1 from "../pages/AuthenticationInner/Register";


import LoginIn from "../pages/Login/LoginIn";
// import BusinessLite from "../pages/Form/forms/ApplyBusinessLite";
import TestForm from "../components/InputField/TestForm";
import Disclosures from "../pages/Disclosures/Disclosures";
import ApplyIndividualLite from "../pages/Form/forms/ApplyIndividualLite";
import BusinessApplicationEntry from "../pages/Form/forms/BusinessApplicationEntry";
import ApplyIndividualLiteContent from "../pages/Form/forms/ApplyIndividualLiteContent";
import ApplyBusinessPrimeContent from "../pages/Form/forms/BPrime/ApplyBusinessPrimeContent";
import ApplyBusinessLiteContent from "../pages/Form/forms/BusinessLiteForms/ApplyBusinessLiteContent";
import BplusCheckout from "../pages/Form/forms/BusinessLiteForms/BplusCheckout";
import ApplyBusinessV2 from "../pages/Form/forms/BusinessV2/ApplyBusinessV2";
import ApplyBusinessV2Content from "../pages/Form/forms/BusinessV2/ApplyBusinessV2Content";
import PostKYC from "../pages/Form/forms/PostKYC";
import SelectScreen from "../pages/Form/forms/SelectScreen";
import UboDashboard from "../pages/Form/UboDashboard";
import CompleteApplication, { CompleteApplicationDashboard } from "../pages/Form/CompleteApplication";
import DocumentSuccess from "../pages/static/Ondato/DocumentSuccess";
import OndatoSuccess from "../pages/static/Ondato/OndatoSuccess";
import ApplyindividualPlus from "../pages/Form/forms/IndividualPlus/ApplyindividualPlus";
import ApplyBusinessPeriodicReview from "../pages/Form/forms/BusinessPeriodicReview/ApplyBusinessPeriodicReview";
import BrokerLogin from "../pages/Broker/BrokerLogin";
import BrokerDashboard from "../pages/Broker/BrokerDashboard";
import BrokerApplications from "../pages/Broker/BrokerApplications";
import BrokerApplicationNew from "../pages/Broker/BrokerApplicationNew";
import BrokerApplicationEdit from "../pages/Broker/BrokerApplicationEdit";
import BrokerApplicationDetail from "../pages/Broker/BrokerApplicationDetail";
import BrokerTeam from "../pages/Broker/BrokerTeam";
import BrokerSettings from "../pages/Broker/BrokerSettings";

const userRoutes = [
  { path: "/business-plus/:edit_id", Component: BusinessApplicationEntry, forUser: true },
  { path: "/business-plus/cart/:edit_id", Component: BplusCheckout, forUser: true },
  { path: "/business-plus/cart/:edit_id/:prime_id", Component: BplusCheckout, forUser: true },
  { path: "/business-prime-plus/:edit_id", Component: BusinessApplicationEntry, forUser: true },
  { path: "/business-prime/:edit_id", Component: BusinessApplicationEntry, forUser: true },
  { path: "/business-v2/upgrade/:edit_id", Component: ApplyBusinessV2, forUser: true },
  { path: "/business-v2/:edit_id", Component: ApplyBusinessV2, forUser: true },
  { path: "/verify-individual/dashboard", Component: UboDashboard, forUser: true },
  { path: "/complete-application/:token/dashboard", Component: CompleteApplicationDashboard, forUser: true },
  { path: "/individual-plus/:individual_id", Component: ApplyIndividualLite, forUser: true },
  { path: "/periodic-review-individual-plus/:individual_id", Component: ApplyindividualPlus, forUser: true },
  { path: "/periodic-review-individual-prime/:individual_id", Component: ApplyindividualPlus, forUser: true },
  { path: "/periodic-review-business-plus/:business_id", Component: ApplyBusinessPeriodicReview, forUser: true },
  { path: "/periodic-review-business-prime/:business_id", Component: ApplyBusinessPeriodicReview, forUser: true },
];

const brokerRouteDefinitions = [
  { path: "/dashboard", Component: BrokerDashboard },
  { path: "/applications", Component: BrokerApplications },
  { path: "/applications/new", Component: BrokerApplicationNew },
  { path: "/applications/:edit_id/edit", Component: BrokerApplicationEdit },
  // Detail renders the grid, which opens the full BrokerApplicationDetail in a
  // right-side drawer over the grid (console-style), so there is no separate page.
  { path: "/applications/:applicationId", Component: BrokerApplications },
  { path: "/team", Component: BrokerTeam },
  { path: "/settings", Component: BrokerSettings },
];

const brokerRoutes = ["/broker", "/brokers", "/platform"].flatMap((basePath) => (
  brokerRouteDefinitions.map(({ path, Component }) => ({ path: `${basePath}${path}`, Component }))
));

const getPeriodicReviewUnauthUrl = () => {
  if (typeof window === "undefined") {
    return "periodic-review/login";
  }
  const { pathname = "", search = "" } = window.location;
  const sanitizedPath = pathname.replace(/^\//, "") || "periodic-review/login";
  return `${sanitizedPath}${search}`;
};

const getBusinessV2LoginForm = ({ upgrade = false } = {}) => {
  const queryType = typeof window === "undefined"
    ? null
    : Number(new URLSearchParams(window.location.search).get("type"));
  const isPrimeLogin = upgrade || queryType === 2;
  const type = upgrade ? 3 : isPrimeLogin ? 2 : 1;
  const path = upgrade
    ? "business-v2/upgrade"
    : type === 2
      ? "business-prime-plus"
      : "business-plus";
  const unauthUrl = path;

  return {
    apiPath: "business",
    path,
    formType: upgrade ? "BUSINESS_PRIME" : "BUSINESS_PLUS",
    unauthUrl,
    type,
    name: upgrade
      ? "Business Prime Upgrade"
      : isPrimeLogin
        ? "Business Prime"
        : "Business Plus",
    defaultType: type,
  };
};

const openRoutes = [
  // { path : "/" , Component : Login},
  { path: "/logout", Component: Logout },
  { path: "/broker", Component: BrokerLogin },
  { path: "/brokers", Component: BrokerLogin },
  { path: "/platform", Component: BrokerLogin },
  { path: "/post-kyc", Component: PostKYC, forUser: true },
  {
    path: "/",
    exact: true,
    Component: () => {
      // On the dedicated broker portal (e.g. rampup-uat.fvbank.us) the bare
      // root has no SelectScreen — send visitors straight to /broker.
      if (isBrokerPortalHost()) {
        return <Navigate to={BROKER_PORTAL_LANDING} replace />;
      }
      return <SelectScreen />
    },
  },
  { path: "/individual-plus/login", Component: () => { return <Loginnew isUser form={{ apiPath: "individual-lite", path: "individual-plus", formType: "INDIVIDUAL_PLUS", unauthUrl: "individual-plus", name: "Individual Plus" }} /> } },
  {
    path: "/periodic-review/login",
    Component: () => {
      return (
        <Loginnew
          isUser
          form={{
            formType: "EDD",
            unauthUrl: getPeriodicReviewUnauthUrl(),
            name: "Periodic Review",
          }}
        />
      );
    },
  },
  { path: "/business-plus/login", Component: () => { return <Loginnew isUser form={getBusinessV2LoginForm()} /> } },
  { path: "/business-prime-plus/login", Component: () => { return <Loginnew isUser form={{ ...getBusinessV2LoginForm(), path: "business-prime-plus", unauthUrl: "business-prime-plus", type: 2, defaultType: 2, name: "Business Prime" }} /> } },
  { path: "/business-prime/login", Component: () => { return <Loginnew isUser form={{ path: "business-prime", formType: "BUSINESS_PRIME", unauthUrl: "business-prime", name: "Business Prime" }} /> } },
  { path: "/business-v2/login", Component: () => { return <Loginnew isUser form={getBusinessV2LoginForm()} /> } },
  { path: "/business-v2/upgrade/login", Component: () => { return <Loginnew isUser form={getBusinessV2LoginForm({ upgrade: true })} /> } },
  { path: "/verify-individual", Component: () => { return <Loginnew isUser form={{ redirectPath: "/verify-individual/dashboard", type : "kyc", name: "Login", unauthUrl: "verify-individual", }} /> } },
  { path: "/complete-application/:token", Component: CompleteApplication },
  {
    path: "/individual-plus", Component: () => { return <ApplyIndividualLiteContent /> }
  },
  // { path: "/business-plus", Component: () => { return <Loginnew isUser form={{ path: "business-plus", name: "Business Plus" }} /> } },
  { path: "/business-plus", Component: () => { return <ApplyBusinessLiteContent /> } },
  { path: "/business-prime", Component: () => { return <ApplyBusinessPrimeContent /> } },
  { path: "/business-v2", Component: () => { return <ApplyBusinessV2Content /> } },
  { path: "/kyc/success", Component: () => { return <OndatoSuccess /> } },
  { path: "/document-captured/success", Component: () => { return <DocumentSuccess /> } },

  { path: "/forgot-password", Component: ForgetPwd },
  { path: "/:formType/disclosure", Component: Disclosures },
  { path: "/register", Component: Register },
  { path: "/login", Component: LoginIn },
 

  { path: "/pages-maintenance", Component: PagesMaintenance },
  // { path: "/pages-comingsoon", Component: ComingSoon },
  { path: "/pages-404", Component: Pages404 },
  { path: "/pages-500", Component: Pages500 },
  { path: "/demo", Component: TestForm },

  // Authentication Inner
  { path: "/pages-login", Component: Login1 },
  { path: "/pages-register", Component: Register1 },
  { path: "/page-recoverpw", Component: Recoverpw },
  { path: "/auth-lock-screen", Component: LockScreen },
];

export { openRoutes, userRoutes, brokerRoutes };
